<h1 mat-dialog-title>Are you sure</h1>
<div mat-dialog-content>
  <p [innerHTML]="message"></p>
</div>
<div mat-dialog-actions align="center">
  <textarea class="decline-chat-dialog-input" placeholder="Please add a private response to the user" [(ngModel)]="adminReply"></textarea>
  <button class="btn btn-default" [mat-dialog-close] cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary" [mat-dialog-close]="adminReply">Reply Privately</button>
</div>
